module.exports = "<div class=\"row\">\r\n  <div class=\"page-header\">\r\n    <h1 [innerHtml]=\"news.Title\"></h1>\r\n  </div>\r\n  <div class=\"col-lg-12\">\r\n    <div [innerHtml]=\"news.Content\"></div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/news/news-detail/news-detail.component.html
// module id = 833
// module chunks = 1